/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, minLength, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusResetPasswordDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusResetPasswordDtoInitialValue(): LexplusResetPasswordDto {
  return {
  email: '',
  token: '',
  password: '',
  changetype: "self",
} as LexplusResetPasswordDto;
}

/**
 * Reusable Signal Forms schema for LexplusResetPasswordDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusResetPasswordDtoSchema(path: SchemaPathTree<LexplusResetPasswordDto>): void {
  required(path.email);
  minLength(path.email, 1);
  required(path.token);
  minLength(path.token, 1);
  required(path.password);
  minLength(path.password, 1);
  required(path.changetype);
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusResetPasswordDtoForm(initial?: Partial<LexplusResetPasswordDto>) {
  const model: WritableSignal<LexplusResetPasswordDto> = signal<LexplusResetPasswordDto>({
    ...getLexplusResetPasswordDtoInitialValue(),
    ...initial,
  } as LexplusResetPasswordDto);
  return { model, field: form(model, lexplusResetPasswordDtoSchema) };
}
